export default __webpack_public_path__ + "static/media/single-line-blackboard-low.6bdf11eb.jpg";